import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BlogSidebar from "../BlogSidebar/BlogSidebar.js";
import client, { urlFor } from "../../sanity/sanityClient";
import { PortableText } from "@portabletext/react";

const BlogSingle = (props) => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "post" && slug.current == $slug][0]{
          title,
          body,
          mainImage,
          publishedAt,
          "authorName": author->name,
          "authorImage": author->image,
          tags
        }`,
        { slug }
      )
      .then((data) => {
        setBlog(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blog post:", error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <p>Loading blog post...</p>;
  if (!blog) return <p>Blog post not found.</p>;

  const components = {
    types: {
      image: ({ value }) => (
        <img
          src={urlFor(value.asset).width(800).url()}
          alt={value.alt || "Image"}
        />
      ),
    },
    marks: {
      link: ({ children, value }) => (
        <a href={value.href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ),
    },
    block: {
      h1: ({ children }) => <h1>{children}</h1>,
      h2: ({ children }) => <h2>{children}</h2>,
      h3: ({ children }) => <h3>{children}</h3>,
      blockquote: ({ children }) => <blockquote>{children}</blockquote>,
    },
  };

  const submitHandler = (e) => {
    e.preventDefault();
  };

  return (
    <section className="wpo-blog-single-section section-padding">
      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-blog-content">
              <div className="post format-standard-image">
                <div className="entry-media">
                  {blog.mainImage && (
                    <img
                      src={urlFor(blog.mainImage).width(800).url()}
                      alt={blog.title}
                    />
                  )}
                </div>
                <div className="entry-meta">
                  <ul>
                    <li>
                      <i className="fi flaticon-user"></i> By{" "}
                      <Link to="/about">{blog.authorName}</Link>
                    </li>
                    <li>
                      <i className="fi flaticon-calendar"></i>{" "}
                      {new Date(blog.publishedAt).toLocaleDateString()}
                    </li>
                  </ul>
                </div>
                <h2>{blog.title}</h2>
                <div className="post-content">
                  <PortableText value={blog.body} components={components} />
                </div>

                {blog.tags && (
                  <div className="tag-share clearfix">
                    <div className="tag">
                      <span>Tags: </span>
                      <ul>
                        {blog.tags.map((tag, idx) => (
                          <li key={idx}>
                            <Link to={`/blog?tag=${tag}`}>{tag}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                <div className="tag-share-s2 clearfix">
                  <div className="tag">
                    <span>Share: </span>
                    <ul>
                      <li>
                        <a
                          href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Facebook
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://twitter.com/intent/tweet?url=${
                            window.location.href
                          }&text=${encodeURIComponent(blog.title)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Twitter
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://www.linkedin.com/shareArticle?mini=true&url=${
                            window.location.href
                          }&title=${encodeURIComponent(
                            blog.title
                          )}&summary=${encodeURIComponent(
                            blog.body
                              .filter((block) => block._type === "block")
                              .map((block) =>
                                block.children
                                  .map((child) => child.text)
                                  .join(" ")
                              )
                              .join(" ")
                              .slice(0, 150) + "..."
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          LinkedIn
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="author-box">
                  <div className="author-avatar">
                    {blog.authorImage && (
                      <img
                        src={urlFor(blog.authorImage).width(100).url()}
                        alt={blog.authorName}
                      />
                    )}
                  </div>
                  <div className="author-content">
                    <Link to="/about" className="author-name">
                      Author: {blog.authorName}
                    </Link>
                    <p>
                      Taisha is a dedicated community leader with a strong
                      vision for a prosperous and equitable Erie County. Her
                      passion for public service drives her commitment to
                      transparency and advocacy for all residents.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BlogSidebar blLeft={props.blLeft} />
        </div>
      </div>
    </section>
  );
};

export default BlogSingle;
